import i18n from 'i18next';

export function getLang() {
  return i18n.language;
}
